import { memo } from 'react';
import type { SvgIconComponent } from '@mui/icons-material';
import clsx from 'clsx';

interface Props extends React.HTMLAttributes<HTMLButtonElement> {
  icon: SvgIconComponent;
  type: 'button' | 'submit' | 'reset';
  notifications?: unknown[];
  notificatonsCount?: number;
}

export const IconButton = memo(({ className, icon: Icon, notifications, notificatonsCount, ...rest }: Props) => {
  const isShowingNotification = notifications && !!notificatonsCount;

  return (
    <button
      {...rest}
      className={clsx(
        'bg-secondary-light text-primary w-full h-full flex items-center justify-center rounded-full relative focus:outline-none focus:ring-2 focus:bg-primary focus:border-transparent',
        className
      )}>
      {Icon && <Icon className="text-secondary-bg" />}
      {isShowingNotification ? (
        <span className="absolute top-0 right-0 flex items-center justify-center w-4 h-4 transition-all bg-red-500 rounded-full">
          <p className="font-light text-primary text-2xs">{notificatonsCount}</p>
          <span className="w-4 h-4 flex justify-center items-center bg-red-500 rounded-full absolute top-0 right-0 transition-all animate-ping opacity-30 animation-delay-1.5" />
        </span>
      ) : null}
    </button>
  );
});
